'use strict';

/* global $ */

let _g = {};

/** @type {String} session id */
function detectSessionID(){
    let sessionId = '';
    if (window.location.toString().match(/SESS_ID=(\d+)/)) {
        sessionId = RegExp.$1;
    }
    return sessionId;
}

/* Параметры fancybox по умолчанию */
let fancybox = {
    padding: 10,
    wrapCSS: 'alfales-fancy',
    helpers: {
        title: { type: 'inside' },
        overlay : {
            css : {
                'background' : 'rgba(106, 50, 30, 0.8)'
            }
        }
    }
};

/* ID сессии, на случай, если у пользователя отключены куки */
let ajax = {
    DATA_TYPE: 'json',   /* dataType ajax запроса по умолчанию */
    URI: '/json/',  /* Адрес на который уходит ajax запрос */
    METHOD: 'post', /* Метод запроса по умолчанию */
    TIMEOUT: 5000   /* Таймаут запроса */,
    SESSION_ID: detectSessionID()
};

let interfaceName = '';

/**
 * Функция определения текущего интерфейса страницы
 */
function getInterfaceName(){
    if(!interfaceName){
        _g.$body = $(document.body);
        interfaceName = _g.$body.data('interfaceName');
    }
    return interfaceName;
}

// let scrollBody = null;

/**
 * Функция определения области прокрутки
 */
// function getScrollBody(){
//     var userAgent = navigator.userAgent.toLowerCase();
//     var _webkit = /webkit/.test(userAgent);
//     scrollBody = (_webkit) ? document.body : document.documentElement;
// }

getInterfaceName();
// getScrollBody();

export {
    interfaceName,
    // scrollBody,
    ajax,
    fancybox
};